<!--
  O mesmo que temos hoje
  Conteúdo será revisado posteriormente
  Tirar última frase em negrito da página de educ. infantil
-->
<template>
  <section>
    <h3>
      <a href="/institucional/seguro-dos-alunos">
        <v-icon>security</v-icon>Seguro dos Alunos
      </a>
    </h3>
    <p>Você sabia que todos os alunos da Escola Engenho são automaticamente cobertos com um seguro de até 10.000 reais para acidentes dentro e fora da escola?</p>
    <p style="text-align:right !important;">
      <v-btn
        href="/institucional/seguro-dos-alunos"
        small
        depressed
        outline
        round
        color="primary"
      >ver mais</v-btn>
    </p>
  </section>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



